import React, { useState, useEffect, useRef } from 'react';
import NavBar from '../../components/nav/NavBar';
import Footer from '../../components/footer/Footer';
import { Link } from 'react-router-dom';
import Vector from "../../assets/images/blackArrow.svg";
import chatbotPhoto from '../../assets/images/chatbotAI.png';
import sendbtn from '../../assets/images/send 1@2x.png';
import microphoneIcon from '../../assets/images/microphone.svg';
import cameraIcon from '../../assets/images/camera.svg';

export default function ChatBot() {
    const [messages, setMessages] = useState([]);
    const [conversationHistory, setConversationHistory] = useState([]);
    const storedUserData = JSON.parse(localStorage.getItem('userData'));
    const userPhoto = storedUserData.image_url;
    const recognition = useRef(null);
    const [recording, setRecording] = useState(false);
    const bottomRef = useRef(null);

    useEffect(() => {
        if ('SpeechRecognition' in window || 'webkitSpeechRecognition' in window) {
            recognition.current = new (window.SpeechRecognition || window.webkitSpeechRecognition)();
            recognition.current.lang = 'en-US';
            recognition.current.continuous = false;
            recognition.current.interimResults = false;

            recognition.current.onresult = event => {
                let transcript = event.results[event.results.length - 1][0].transcript;
                transcript = transcript.trim().replace(/\.$/, '');
                document.getElementsByName('messageInput')[0].value += transcript;
            };

            recognition.current.onend = () => {
                setRecording(false);
            };

            recognition.current.onerror = event => {
                console.error('Speech recognition error:', event.error);
                recognition.current.stop();
                setRecording(false);
            };
        } else {
            console.error('Speech recognition not supported');
        }

        return () => {
            if (recognition.current) {
                recognition.current.stop();
            }
        };
    }, []);

    const handlePhotoSelect = (event) => {
        const file = event.target.files[0];
        if (file) {
            const reader = new FileReader();
            reader.onloadend = () => {
                const base64Image = reader.result.split(',')[1];
                addMessage(null, reader.result); // Add image message first
                processImage(base64Image);
            };
            reader.readAsDataURL(file);
        }
    };

    const processImage = async (base64Image) => {
        const apiUrl = 'https://generativelanguage.googleapis.com/v1beta/models/gemini-1.5-flash:generateContent?key=AIzaSyBSbUr0TmCMSGcFOdsO24PUOEsLmQu-8ec';

        const requestBody = JSON.stringify({
            "contents": [
                {
                    "parts": [
                        { "text": "I'll provide you with a touristic place, I just need you to give me the name of this place,If you were asked a question outside the context of tourism or something a tour guide cant respond tell that you are only a tour guide and con not respond to that context asked, do not write '*' or '#',do not make any bold text , i want text to be normal." },
                        {
                            "inline_data": {
                                "mime_type": "image/jpeg",
                                "data": base64Image
                            }
                        }
                    ]
                }
            ]
        });

        try {
            const response = await fetch(apiUrl, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: requestBody
            });

            if (response.ok) {
                const responseData = await response.json();
                const placeName = responseData?.candidates[0]?.content?.parts[0]?.text || "Unknown place";
                const chatbotPrompt = `Tell me a description about ${placeName} , do not write '*' or '#',do not make any bold text , i want text to be normal,If you were asked a question outside the context of tourism or something a tour guide cant respond tell that you are only a tour guide and con not respond to that context asked  `;
                fetchResponse(chatbotPrompt);
            } else {
                console.error('Failed to fetch image response');
                addChatbotMessage("Error processing the image");
            }
        } catch (error) {
            console.error('Error:', error);
            addChatbotMessage("Error processing the image");
        }
    };

    const startListening = () => {
        if (recognition.current && !recording) {
            recognition.current.start();
            setRecording(true);
        }
    };

    const addChatbotMessage = (text, photo = null) => {
        const chatbotMessage = {
            text,
            sender: 'chatbot',
            photo
        };
        setMessages(prev => [chatbotMessage, ...prev]);
        setConversationHistory(prev => [...prev, chatbotMessage.text]);
    };

    const addMessage = (text, photo = null) => {
        const newMessage = {
            text,
            sender: 'user',
            photo
        };
        setMessages(prev => [newMessage, ...prev]);
        if (text) {
            setConversationHistory(prev => [...prev, text]);
        }
    };

    const handleSubmitted = (event) => {
        event.preventDefault();
        const text = event.target.elements.messageInput.value.trim();
        if (text) {
            addMessage(text); 
            fetchResponse(text);
        }

        if (recognition.current && recording) {
            recognition.current.stop();
            setRecording(false);
        }

        event.target.reset();
    };

    const fetchResponse = async (text) => {
        const apiUrl = 'https://generativelanguage.googleapis.com/v1beta/models/gemini-1.5-flash:generateContent?key=AIzaSyBSbUr0TmCMSGcFOdsO24PUOEsLmQu-8ec';
        try {
            const promptWithHistory = conversationHistory.join('\n') + '\n' + text;
            const requestBody = JSON.stringify({
                "contents": [
                    {
                        "parts": [
                            { "text": promptWithHistory +`If you were asked a question outside the context of tourism or something a tour guide cant respond tell that you are only a tour guide and con not respond to that context asked, do not write '*' or '#',do not make any bold text , i want text to be normal`}
                        ]
                    }
                ]
            });
            const response = await fetch(apiUrl, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: requestBody
            });
            if (response.ok) {
                const responseData = await response.json();
                const chatbotTextResponse = responseData?.candidates[0]?.content?.parts[0]?.text || "No response";
                const chatbotImageResponse = responseData?.candidates[0]?.content?.parts[1]?.inline_data?.data || null;

                addChatbotMessage(chatbotTextResponse, chatbotImageResponse);
            } else {
                console.error('Failed to fetch response');
                addChatbotMessage("Error processing the text");
            }
        } catch (error) {
            console.error('Error:', error);
            addChatbotMessage("Error processing the text");
        }
    };

    return (
        <>
            <NavBar />

            <div className='chatbot-holder'>
                <div className='chatbot-name'>
                    <div className='chatbot-name-holder' >
                        <div className='arrow-holder'>
                            <Link to={'/'}>
                                <img className='left-chatbot-arrow' src={Vector} alt='arrow-icon' />
                            </Link>
                        </div>
                        <p className='chatbot-link'>Tourbot</p>
                    </div>
                </div>
                <div className='conv'>
                    {messages.map((message, index) => (
                        <div key={index} className={`message ${message.sender}`}>
                            {message.text && <p>{message.text}</p>}
                            {message.photo && (
                                <div className="photo-container">
                                    <img className="chat-photo" src={message.photo} alt='userPhoto' />
                                </div>
                            )}
                            <img src={message.sender === 'user' ? userPhoto : chatbotPhoto} alt='profile' />
                        </div>
                    ))}
                    <div ref={bottomRef}></div>
                </div>
                <div className='chat-input-container'>
                    <form className='mamamama' onSubmit={handleSubmitted}>
                        <div className='chat-input'>
                            <input name="messageInput" type="text" autoComplete="off" placeholder="Type your message here.." />
                            <label className='chatbot-camera' htmlFor="fileInput">
                                <img src={cameraIcon} alt='camera' className='chat-i' />
                            </label>
                            <input id="fileInput" type="file" accept="image/*" style={{ display: 'none' }} onChange={handlePhotoSelect} />
                            <button className='chatbot-microphone' type="button" onClick={startListening}>
                                <img className='img-chatbot-microphone chat-i' src={microphoneIcon} alt='microphone' />
                            </button>
                            <button className='chatbot-sendbtn' type="submit">
                                <img className='img-chatbot-sendbtn chat-i' src={sendbtn} alt='sendArrow' />
                            </button>
                        </div>
                    </form>
                </div>
            </div>
            <Footer />
        </>
    );
}
